import { createSelector } from 'reselect'

import { selectHasTeam, selectTeamsSupported } from './userTeamSelectors'
import { selectHasOffice } from './accountSelectors'

export const selectHomeMyTeamVisible = createSelector(
  [selectTeamsSupported, state => state.userTeam.errorLoadingUserTeam, selectHasTeam],
  (isTeamsSupported, errorLoadingUserTeam, hasTeam) =>
    isTeamsSupported && !errorLoadingUserTeam && hasTeam,
)

export const selectAccountsVisible = createSelector(
  [
    selectTeamsSupported,
    state => state.userTeam.errorLoadingUserTeam,
    selectHasTeam,
    selectHasOffice,
  ],
  (isTeamsSupported, errorLoadingUserTeam, hasTeam, hasOffice) =>
    isTeamsSupported && !errorLoadingUserTeam && (hasTeam || hasOffice),
)
